import {SET_PURCHASE_ORDER_STATUSES} from '../actionTypes';
import {IGenericType} from 'constants/interfaces';

export type PurchaseOrderStatusesState = {
  lastUpdate: number;
  purchaseOrderStatuses: IGenericType[];
};
const initialState: PurchaseOrderStatusesState = {
  lastUpdate: 0,
  purchaseOrderStatuses: [],
};

export default function (
  state = initialState,
  action: {type: string; payload: any},
) {
  switch (action.type) {
    case SET_PURCHASE_ORDER_STATUSES: {
      const statuses: IGenericType[] = action.payload || [];
      const stateUpdate: PurchaseOrderStatusesState = {
        lastUpdate: new Date().getTime(),
        purchaseOrderStatuses: statuses.map((status) => ({...status})),
      };
      return stateUpdate;
    }

    default:
      return state;
  }
}
